import { Benefits } from '../Benefits';
import { HowItWorks } from '../HowItWorks';
import { Utp } from '../Utp';
import { HOW_IT_WORKS } from 'shared/constants/howItWorks';
import { HowConnectDiscount } from '../HowConnectDiscount';
import { DiscountBanner } from '../DiscountBanner';
import { IButtonLinkContainerProps } from 'shared/containers/ButtonLinkContainer';
import { caMyOffers } from '../tracking';
import { TDeviceType } from '@cian/ui-kit';
import { IHowConnectDiscountItem } from 'shared/types/howConnectDiscount';
import { BENEFITS } from 'shared/constants/benefits';
import { Notice } from '../Notice';

interface IContentProps {
  answersOnQuestions: JSX.Element;
  discountConditions: JSX.Element;
  videoBlock: JSX.Element;
  howGetDeal: JSX.Element;
  calculator: JSX.Element;
  needConsultation: JSX.Element;
  ButtonLink: React.FC<IButtonLinkContainerProps>;
  HowConnectDiscountItem: React.FC<IHowConnectDiscountItem>;
  device: TDeviceType;
}

export const Content: React.FC<IContentProps> = ({
  answersOnQuestions,
  discountConditions,
  videoBlock,
  howGetDeal,
  needConsultation,
  calculator,
  ButtonLink,
  HowConnectDiscountItem,
  device,
}) => {
  return (
    <>
      <DiscountBanner />
      <Utp title="Как это работает?" ItemForRender={HowItWorks} items={HOW_IT_WORKS} />
      <Utp title="Выгода для всех участников сделки" isRowDirection ItemForRender={Benefits} items={BENEFITS} />
      {discountConditions}
      <HowConnectDiscount
        Item={HowConnectDiscountItem}
        buttonLink={<ButtonLink onSendCa={() => caMyOffers(device)}>Мои объявления</ButtonLink>}
      />
      {howGetDeal}
      {videoBlock}
      {calculator}
      {needConsultation}
      {answersOnQuestions}
      <Notice />
    </>
  );
};
